import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import CardContainer from 'src/components/common/CardContainer.redesign';
import CardSection from 'src/components/common/CardSection';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Leasehold from 'src/models/leasehold/Leasehold';
import useFetch from 'use-http';
import LeaseholdExtensionCard from '../../LeasingComponents/LeaseholdExtensionCard';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import LeaseholdCardData from 'src/models/leasehold/LeaseholdCardData';
import Card from 'src/components/common/Card.redesign';

interface IExtendLeaseholdsDialogProps {
    dialogName: string;
    leaseholds: Leasehold[];
    resetForm: () => void;
}

const ExtendLeaseholdsDialog = (props: IExtendLeaseholdsDialogProps) => {
    const { handleSubmit } = useForm();
    const { put } = useFetch();
    const appContext = useContext<IAppContextState>(AppContext);

    const [changesSubmitted, setChangesSubmitted] = useState<boolean>(false);
    const [leaseholdCards, setLeaseholdCards] = useState<LeaseholdCardData[]>(undefined);

    const submitExtensionForm = async (leaseholdId: number) => {
        if (!!leaseholdId && leaseholdId > 0) {
            await put(`v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/fields/${appContext.fieldNumber}/tracts/${appContext.tractNumber}/ownership/${appContext.ownershipId}/leasehold/extend-option/${leaseholdId}`);
        }

        props.resetForm();
    };

    const onSubmit = () => {
        setChangesSubmitted(true);
    };

    useEffect(() => {
        console.log('Dialog Props', props);

        let tracts: LeaseholdCardData[] = [];
        props.leaseholds?.forEach(lh => {
            let index = tracts.indexOf(tracts.find(t => t.tractName === lh.tractName));

            if (index > -1) {
                tracts[index].leaseholds.push(lh);
            } else {
                let newTract: LeaseholdCardData = {tractName: lh.tractName, leaseholds: [lh]};
                tracts.push(newTract);
            }
        });

        setLeaseholdCards(tracts);
    }, [props.leaseholds]);

    return (
        <Dialog title="Extend Leaseholds" dialogName={props.dialogName} bodyStyle={{ width: '75%' }}>
            <CardSection title="Project Staff">
                <div style={{ display: 'flex',  maxHeight: '60vh', overflow: 'auto' }}>
                    <div style={{ width: '100%' }}>
                        <CardContainer style={{ overflowY: 'scroll' }} >
                            <div className="mb-1 mt-1">
                                {leaseholdCards && (
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        {leaseholdCards.map((tr, trKey) => {
                                            return (
                                                <div key={`Tract ${trKey}`}>
                                                    <Card
                                                        badge={`${tr.tractName || 'N/A'}`}
                                                        newContext={true}
                                                    >
                                                        {tr.leaseholds?.map((lh, key) => {
                                                            return (
                                                                <div key={`Leasehold ${key}`}>
                                                                    <LeaseholdExtensionCard
                                                                        leasehold={lh}
                                                                        index={key}
                                                                        submitListener={changesSubmitted}
                                                                        submitExtensionForm={submitExtensionForm}
                                                                    />
                                                                </div>
                                                            );
                                                        })}                                       
                                                    </Card>
                                                </div>
                                            );
                                        })}
                                        <div style={{ padding: '1rem' }}>
                                            <Button text="Submit" intent="primary" type="submit"/>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </CardContainer>
                    </div>
                </div>
            </CardSection>
        </Dialog>
    );
};

export default ExtendLeaseholdsDialog;


// WEBPACK FOOTER //
// ./src/components/project/sections/tract/dialogs/ExtendLeaseholdsDialog.tsx